import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import BillDetail from 'saas/common/bill/BillDetail';
import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import moment from 'moment/moment';

const setPaymentDate = (invoiceDate, modificationAllowed) => {
  if (invoiceDate) {
    $('#invoiceDate').val(invoiceDate.format('DD/MM/YYYY'));
  } else {
    $('#invoiceDate').val('');
  }

  if (modificationAllowed) {
    $('#invoiceDate')
      .removeClass('disabled')
      .removeClass('ui')
      .removeClass('field');
  } else {
    $('#invoiceDate')
      .addClass('disabled')
      .addClass('ui')
      .addClass('field');
  }
};

const applyPaymentDelay = mode => {
  if (mode === '30_DAYS') {
    setPaymentDate(moment().add(30, 'days'), false);
  } else if (mode === '60_DAYS') {
    setPaymentDate(moment().add(60, 'days'), false);
  } else if (mode === '30_DAYS_END_MONTH') {
    setPaymentDate(
      moment()
        .add(30, 'days')
        .endOf('month'),
      false
    );
  } else if (mode === '45_DAYS_END_MONTH') {
    setPaymentDate(
      moment()
        .add(45, 'days')
        .endOf('month'),
      false
    );
  } else if (mode === 'CUSTOM') {
    setPaymentDate(moment().add(7, 'days'), true);
  }
};

export const bindLinesForm = $form => {
  // Handling estimate and invoice toggle

  const $toggle = $('.estimates, .invoices').find('.toggle');
  $toggle.each((_, element) => {
    const isChecked = $(element).checkbox('is checked');
    const $dimmer = $(element)
      .closest('.lines')
      .find('.dimmer');

    $dimmer.dimmer({ closable: false });

    if (isChecked) {
      $dimmer.dimmer('hide');
    } else {
      $dimmer.dimmer('show');
    }
  });

  $toggle.checkbox();

  const setActionValueFromButton = ($input, $button) => {
    $input.val($button.attr('data-value'));
  };

  const setDefaultButton = dataValue => {
    const $estimateActionButtons = $('.estimateActionBtn');
    const $invoiceActionButtons = $('.invoiceActionBtn');

    if (!$estimateActionButtons.hasClass('active')) {
      const $button = $(
        `.actions.buttons.estimate button[data-value="${dataValue}"]`
      );
      $button.addClass('active');
      $button.addClass('secondary');

      if ($('input[name="estimateAction"]').length) {
        setActionValueFromButton($('input[name="estimateAction"]'), $button);
      } else {
        setActionValueFromButton($('input[name="estimate.action"]'), $button);
      }
    }

    if (!$invoiceActionButtons.hasClass('active')) {
      const $button = $(
        `.actions.buttons.invoice button[data-value="${dataValue}"]`
      );
      $button.addClass('active');
      $button.addClass('secondary');

      if ($('input[name="invoiceAction"]').length) {
        setActionValueFromButton($('input[name="invoiceAction"]'), $button);
      } else {
        setActionValueFromButton($('input[name="invoice.action"]'), $button);
      }
    }
  };

  // Handling payment delay
  $('#paymentDelay').on('change', evt => {
    evt.preventDefault();
    applyPaymentDelay($(evt.target).val());
  });
  applyPaymentDelay($('#paymentDelay').val());

  // Handling lines action
  const $actions = $('.separated.actions.buttons');
  $actions.each((_, element) => {
    const $action = $(element);
    const $actionInput = $action.parent().find('input[type="hidden"]');

    $action
      .find('button')
      .off('click')
      .on('click', evt => {
        const $button = $(evt.target);

        // Toggling button state
        $button
          .closest('.actions.buttons')
          .find('button')
          .removeClass('active secondary');
        $button.addClass('secondary');

        // Updating input
        setActionValueFromButton($actionInput, $button);
      });

    const initialValue = $actionInput.val();
    $action.find(`button[data-value="${initialValue}"]`).addClass('active');
    $action.find(`button[data-value="${initialValue}"]`).addClass('secondary');
  });

  // Handling toggle updates
  $toggle
    .find('input')
    .off('change')
    .on('change', evt => {
      const isChecked = evt.target.checked;
      const $target = $(evt.target);

      // Toggling dimmer
      $target
        .closest('.lines')
        .find('.dimmer')
        .dimmer('toggle');

      if (isChecked) {
        const $default = $target
          .closest('.lines')
          .find('.actions.buttons button')
          .first();
        const $input = $target.closest('input[type="hidden"]');

        if (
          $target.closest('.lines').find('.actions.buttons button .secondary')
            .length !== 0
        ) {
          $default.addClass('active');

          setActionValueFromButton($input, $default);
        }
      }
    });

  // Rendering lines
  const renderWithRoot = (root, prefix) => {
    const linesAttr = $(`#${root}`).attr('data-lines');
    const name = $(`#${root}`).attr('data-name');
    const beforeLines = $(`#${root}`).attr('data-before');
    const afterLines = $(`#${root}`).attr('data-after');
    const lines = linesAttr && linesAttr.length ? JSON.parse(linesAttr) : [];

    return ReactDOM.render(
      <BillDetail
        lines={lines}
        beforeLinesName={`${prefix}${name}BeforeLines`}
        afterLinesName={`${prefix}${name}AfterLines`}
        textBeforeLines={beforeLines}
        textAfterLines={afterLines}
        documentModelId={`#${prefix}DocumentModelId`}
      />,
      document.getElementById(root)
    );
  };

  const estimatesDOM = renderWithRoot('estimates-root', 'estimate');
  const invoicesDOM = renderWithRoot('invoices-root', 'invoice');
  const $submit = $form.find('button[type="submit"]');

  // Handling form submission
  $form.off('submit').on('submit', evt => {
    evt.preventDefault();

    // Building form data
    const data = new FormData($form[0]);
    $submit.addClass('loading');
    $submit.addClass('disabled');

    const estimatesEnabled = $('.estimates .toggle').checkbox('is checked');
    if (estimatesEnabled) {
      const estimates = estimatesDOM.getLinesAsJson();
      data.append('estimateLines', estimates);
    }

    const invoicesEnabled = $('.invoices .toggle').checkbox('is checked');
    if (invoicesEnabled) {
      const invoices = invoicesDOM.getLinesAsJson();
      data.append('invoiceLines', invoices);
    }

    // Submitting
    const url = $form.attr('action');
    fetch(url, {
      method: 'POST',
      body: data,
    }).then(
      res => {
        $submit.removeClass('loading');
        window.location.replace(res.url);
      },
      err => {
        console.log('Error attempting to save demand template', err);

        $submit.removeClass('disabled');

        hideLoader();
        error('Une erreur est survenue pendant la sauvegarde de la demande');
      }
    );

    return false;
  });

  setDefaultButton('emit');
};



// WEBPACK FOOTER //
// ./src/modules/saas/demands/common.js